import React from "react";
import { Modal } from "react-bootstrap";

const SaveClosingModal = ({ show, handleClose,saveClosingState }) => {
  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header className="save-closing" closeButton>
        <Modal.Title className="text-white save-close-title">Save at Closing: Forgo Title Insurance Fees</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <h5 className="saving-closing-h5">
          Note: With this selection, you are missing out on the benefits of the
          seller's preferred title partner, Premium Title Services, which
          include:
        </h5>
        <h5 className="saving-closing-h5">No Title Insurance and Reduced Escrow/Closing Fees</h5>
        <p className="saving-closing-content mb-0">
          With Premium Title Services, the seller will pay these fees for you.
        </p>
        <p className="saving-closing-content">
          Buyers save an average of {saveClosingState?.price} in {saveClosingState?.state} when using the seller's
          title service provider.
        </p>
        <h5 className="saving-closing-h5">Closing Attorney Assistance</h5>
        <p className="saving-closing-content">
          For Georgia, Premium Title Services has engaged the services of a
          local law firm specializing in real estate closings. If you require or
          opt to use a closing attorney, the local law firm can coordinate the
          closing of your property with your designated attorney.
        </p>
        <h5 className="saving-closing-h5">
          If you'd prefer to engage the services of Premium Title Services,
          please select Seller Pays.
        </h5>
        <div className="text-center">
          <button className="ok-btn-saving" onClick={handleClose}>
            Ok
          </button>
        </div>
      </Modal.Body>
      
    </Modal>
  );
};

export default SaveClosingModal;
